<template>
    <div class="input-container" :class="label ? 'input-container-with-label' : ''" :style="'minWidth: '+ minWidth + 'px'">
        <form-label-title v-if="label" :label="label" :is-required="isRequired" />
        <el-select ref="select-input-ref" 
                   v-model="value"
                   filterable
                   class="select-input"
                   :placeholder="selectPlaceholder"
                   :size="size"
                   :default-first-option="defaultFirstOption"
                   :multiple="multiple"
                   :collapse-tags="isCollapse"
                   clearable
                   :loading="loading"
                   :disabled="disabled"
                   @change="handleChange($event)"
        >
            <el-option
                v-for="(item, index) in options"
                :key="item.id + item.name + index"
                :label="item.name"
                :value="item.id"
                :disabled="item.disabled"
            />
        </el-select>

        <template>
            <el-popover
                v-model="isVisible"
                placement="bottom-start"
                width="400"
                trigger="click"
            >
                <!-- <p class="create-new-title">Create New {{label}}</p> -->
                <div class="new-input-container">
                    <form-input :input-value.sync="name" :label="$t('create.Name')" />
                </div>
                <el-button type="primary" size="mini" @click="okDialog()">{{ $t('button.OK') }}</el-button>
                <el-button size="mini" @click="cancelDialog()">{{ $t('button.Cancel') }}</el-button>

                <p v-if="isCreateOption" slot="reference" class="new-text">{{ $t('string.Create new') }}</p>
            </el-popover>
        </template>
    </div>
</template>

<script>
import FormInput from "./FormInput";
import FormLabelTitle from "./FormLabelTitle";
export default {
    components: {
        "form-input": FormInput,
        "form-label-title": FormLabelTitle,
    },
    props: {
        inputValue: {
            type: String | Number
        },
        label: {
            type: String,
        },
        placeholder: {
            type: String
        },
        options: {
            type: Array | null,
            required: true
        },
        size: {
            type: String,
            default: "small"
        },
        defaultFirstOption: {
            type: Boolean,
        },
        selectStyle: {
            type: String | Object
        },
        isCreateOption: {
            type: Boolean ,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        minWidth: {
            type: String | Number
        },
        collapseTags: {
            type: Boolean
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isRequired: {
            type: Boolean
        }
    },
    data() {
        return {
            name: "",
            isVisible: false,
            isCollapse: false
        };
    },
    computed: {
        value: {
            set(val) {
                if (this.multiple) {
                    this.$emit("update:inputValue", val.toString());

                    // let str = ''
                    // val.forEach(v => {
                    //     if(v != null) {
                    //         str = str + v + ','
                    //     }
                    // })
                    // let opts_formatted = str.substr(0, str.length-3)
                        
                    // this.$emit('update:inputValue', opts_formatted)
                }
                else {
                    this.$emit("update:inputValue", val);
                }
            },
            get() {
                if (this.multiple && this.inputValue) {
                    var valueArr = this.inputValue.split(",");
                    return valueArr;
                }
                else {
                    return this.inputValue;
                }
            }
        },
        selectPlaceholder() {
            if (this.placeholder) return this.placeholder;
            else return this.$t("button.Select");
        }
    },
    mounted() {
        this.checkIsCollapse();
    },
    methods: {
        handleChange(value) {
            this.$emit("handleChange", value);
        },
        okDialog() {
            this.$emit("handleOkCreate", this.name);
            this.isVisible = false;
        },
        cancelDialog() {
            this.isVisible = false;
        },
        checkIsCollapse() {
            this.$nextTick(() => {
                setTimeout(() => {
                    let input_width = this.$refs["select-input-ref"].inputWidth;

                    if (this.collapseTags) {
                        this.isCollapse = this.collapseTags;
                    }
                    else {
                        if (input_width <= 500) {
                            this.isCollapse = true;
                        }
                        else {
                            this.isCollapse = false;
                        }
                    } 
                }, 50);
            });
        }
    }
};
</script>

<style lang="css" scoped>
.select-input{
    width: 100%;
}
.new-text{
    color: var(--main-color-1);
    font-size: var(--select-create-new);
    line-height: var(--select-create-new);
    display: inline-block;
    padding: var(--space-4) var(--space-8);
    margin: var(--space-4) 0;
    background-color: var(--create-new-select-btn);
}
.new-text:hover{
    cursor: pointer;
    background-color: var(--create-new-select-btn-hover);
}
.create-new-title{
    font-size: var(--form-label-size);
    margin-bottom: var(--space-10);
}
.new-input-container {
    margin-bottom: var(--space-10);
}
</style>


// WEBPACK FOOTER //
// src/components/Form/FormSelect.vue